import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { HnService } from "./app.service";
import { SessionService } from "./common/services/session.service";

interface Resolve<T> {
  resolve(): Observable<T> | Promise<T> | T;
}

@Injectable({ providedIn: "root" })
export class HeroResolver implements Resolve<any> {
  constructor(private service: HnService, private ss: SessionService) {}

  resolve(): Observable<any> | Promise<any> | any {
    return this.service.getTopPosts();
  }
}
